import { KeyRound } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/*
 * Porte d'acces administrateur : la cle est saisie a chaque ouverture et ne
 * quitte jamais la memoire du composant parent.
 */
export const AdminLogin = ({ keyInput, setKeyInput, authError, onSubmit }) => (
  <div className="mt-8 rounded-2xl bg-white border border-[rgba(35,82,119,0.14)] p-6 shadow-[var(--shadow-sm)]">
    <div className="flex items-center gap-2 text-[#060606]">
      <KeyRound className="w-4 h-4" aria-hidden="true" />
      <h2 className="font-heading text-base font-semibold">Accès réservé</h2>
    </div>
    <p className="mt-2 text-sm text-[#333333]">Saisis la clé administrateur pour accéder aux paramètres.</p>
    <div className="mt-4">
      <Label htmlFor="admin-key" className="text-sm font-medium text-[#060606]">Clé administrateur</Label>
      <Input
        id="admin-key"
        type="password"
        data-testid="admin-key-input"
        value={keyInput}
        onChange={(e) => setKeyInput(e.target.value)}
        className="mt-1.5 min-h-[48px] rounded-xl border-[rgba(35,82,119,0.18)]"
        placeholder="Clé fournie côté serveur"
      />
    </div>
    {authError && <p className="mt-2 text-xs text-[#D74843]" role="alert" data-testid="admin-auth-error">{authError}</p>}
    <Button
      data-testid="admin-login-button"
      onClick={onSubmit}
      disabled={!keyInput.trim()}
      className="mt-5 w-full min-h-[48px] rounded-xl bg-[#235277] hover:bg-[#1E4767] font-heading font-semibold transition-colors duration-200"
    >
      Accéder aux paramètres
    </Button>
  </div>
);
